module.exports = __webpack_public_path__ + "assets/5ec12c02b97917d57154dd5650cfc7c7.mp4";